import fetch from "@lib/fetch";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { simulationRunsPath } from "./constants";
import type { SimulationRun, SimulationRunsResult, SimulationRunsTableParams } from "./types";
import { isSimulationRunsResult } from "./validators";

export const getSimulationRuns = reactQueryTableFetcherAdapter<
  typeof simulationRunsPath,
  SimulationRunsTableParams,
  SimulationRun,
  SimulationRunsResult
>(
  simulationRunsPath,
  (
    signal: AbortSignal,
    { appGroupId, limit = 20, start = 0 }: SimulationRunsTableParams
  ): Promise<SimulationRunsResult> =>
    fetch(`/${appGroupId}/conversational/simulation/runs`, "GET", { limit, start }, { signal }),
  isSimulationRunsResult
);
